import { Flex, FlexProps, useIsBreakpoint } from '@blockanalitica/ui';
import { ReactNode } from 'react';
import { Outlet } from 'react-router';
import styled, { css } from 'styled-components';
import Footer from './Footer';
import Header from './Header';

export interface WrapperProps {
  $isTablet: boolean;
}

const ContentContainer = styled(Flex)<FlexProps>`
  box-sizing: border-box;
`;

const Wrapper = styled.div<WrapperProps>`
  background-image: url('/assets/backgrounds/home.png');
  background-repeat: no-repeat;
  background-position: top center;

  ${(props) => css`
    ${props.$isTablet ? 'background-size: 150%' : null}
  `}
`;

export default function HomeLayout({ children }: { children?: ReactNode }) {
  const isTablet = useIsBreakpoint(2);
  return (
    <Wrapper $isTablet={isTablet}>
      <ContentContainer
        flexGrow={1}
        flexShrink={1}
        flexBasis={['100%', 'auto']}
        margin="0 auto"
        width="100%"
        maxWidth={['100vw', '90rem']}
        flexDirection="column"
        justifyContent="space-between"
        padding={['m l', 's m']}
        gap="m">
        <Header />

        <main>{children ? children : <Outlet />}</main>

        <Footer />
      </ContentContainer>
    </Wrapper>
  );
}
